import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { CompanySelectorDataProviderFactory } from '../factory/CompanySelectorDataProviderFactory';
import { CompanySelectorBaseDataProvider } from '../dataProvider/CompanySelectorBaseDataProvider';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/dashboards/gz-console';

export class CompanySelectorRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CompanySelectorDataProviderFactory;
  public dataProvider: CompanySelectorBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CompanySelectorDataProviderFactory(),
    });
  }

  async getCompanies(request: GetCompaniesRequest): Promise<GetCompaniesResponse | undefined> {
    return await this.dataProvider.getCompanies(request);
  }
}
